import { addDays, startOfDay } from 'date-fns';

const now = startOfDay(new Date());

export const inverterValues = [
  { date: addDays(now, -180), nb: 31 },
  { date: addDays(now, -179), nb: 30 },
  { date: addDays(now, -178), nb: 31 },
  { date: addDays(now, -177), nb: 31 },
  { date: addDays(now, -176), nb: 31 },
  { date: addDays(now, -175), nb: 31 },
  { date: addDays(now, -174), nb: 30 },
  { date: addDays(now, -173), nb: 30 },
  { date: addDays(now, -172), nb: 31 },
  { date: addDays(now, -171), nb: 31 },
  { date: addDays(now, -170), nb: 31 },
  { date: addDays(now, -169), nb: 31 },
  { date: addDays(now, -168), nb: 30 },
  { date: addDays(now, -167), nb: 30 },
  { date: addDays(now, -166), nb: 31 },
  { date: addDays(now, -165), nb: 31 },
  { date: addDays(now, -164), nb: 30 },
  { date: addDays(now, -163), nb: 30 },
  { date: addDays(now, -162), nb: 31 },
  { date: addDays(now, -161), nb: 30 },
  { date: addDays(now, -160), nb: 30 },
  { date: addDays(now, -159), nb: 31 },
  { date: addDays(now, -158), nb: 30 },
  { date: addDays(now, -157), nb: 29 },
  { date: addDays(now, -156), nb: 29 },
  { date: addDays(now, -155), nb: 30 },
  { date: addDays(now, -154), nb: 28 },
  { date: addDays(now, -153), nb: 30 },
  { date: addDays(now, -152), nb: 31 },
  { date: addDays(now, -151), nb: 31 },
  { date: addDays(now, -150), nb: 31 },
  { date: addDays(now, -149), nb: 31 },
  { date: addDays(now, -148), nb: 30 },
  { date: addDays(now, -147), nb: 30 },
  { date: addDays(now, -146), nb: 31 },
  { date: addDays(now, -145), nb: 30 },
  { date: addDays(now, -144), nb: 31 },
  { date: addDays(now, -143), nb: 30 },
  { date: addDays(now, -142), nb: 31 },
  { date: addDays(now, -141), nb: 30 },
  { date: addDays(now, -140), nb: 31 },
  { date: addDays(now, -139), nb: 31 },
  { date: addDays(now, -138), nb: 29 },
  { date: addDays(now, -137), nb: 31 },
  { date: addDays(now, -136), nb: 31 },
  { date: addDays(now, -135), nb: 31 },
  { date: addDays(now, -134), nb: 31 },
  { date: addDays(now, -133), nb: 31 },
  { date: addDays(now, -132), nb: 31 },
  { date: addDays(now, -131), nb: 31 },
  { date: addDays(now, -130), nb: 30 },
  { date: addDays(now, -129), nb: 31 },
  { date: addDays(now, -128), nb: 30 },
  { date: addDays(now, -127), nb: 31 },
  { date: addDays(now, -126), nb: 31 },
  { date: addDays(now, -125), nb: 31 },
  { date: addDays(now, -124), nb: 31 },
  { date: addDays(now, -123), nb: 31 },
  { date: addDays(now, -122), nb: 31 },
  { date: addDays(now, -121), nb: 30 },
  { date: addDays(now, -120), nb: 31 },
  { date: addDays(now, -119), nb: 30 },
  { date: addDays(now, -118), nb: 28 },
  { date: addDays(now, -117), nb: 31 },
  { date: addDays(now, -116), nb: 31 },
  { date: addDays(now, -115), nb: 30 },
  { date: addDays(now, -114), nb: 30 },
  { date: addDays(now, -113), nb: 31 },
  { date: addDays(now, -112), nb: 30 },
  { date: addDays(now, -111), nb: 31 },
  { date: addDays(now, -110), nb: 31 },
  { date: addDays(now, -109), nb: 31 },
  { date: addDays(now, -108), nb: 31 },
  { date: addDays(now, -107), nb: 31 },
  { date: addDays(now, -106), nb: 30 },
  { date: addDays(now, -105), nb: 31 },
  { date: addDays(now, -104), nb: 30 },
  { date: addDays(now, -103), nb: 30 },
  { date: addDays(now, -102), nb: 31 },
  { date: addDays(now, -101), nb: 31 },
  { date: addDays(now, -100), nb: 31 },
  { date: addDays(now, -99), nb: 29 },
  { date: addDays(now, -98), nb: 30 },
  { date: addDays(now, -97), nb: 30 },
  { date: addDays(now, -96), nb: 31 },
  { date: addDays(now, -95), nb: 31 },
  { date: addDays(now, -94), nb: 31 },
  { date: addDays(now, -93), nb: 30 },
  { date: addDays(now, -92), nb: 30 },
  { date: addDays(now, -91), nb: 31 },
  { date: addDays(now, -90), nb: 31 },
  { date: addDays(now, -89), nb: 31 },
  { date: addDays(now, -88), nb: 30 },
  { date: addDays(now, -87), nb: 31 },
  { date: addDays(now, -86), nb: 29 },
  { date: addDays(now, -85), nb: 30 },
  { date: addDays(now, -84), nb: 31 },
  { date: addDays(now, -83), nb: 30 },
  { date: addDays(now, -82), nb: 31 },
  { date: addDays(now, -81), nb: 30 },
  { date: addDays(now, -80), nb: 31 },
  { date: addDays(now, -79), nb: 30 },
  { date: addDays(now, -78), nb: 30 },
  { date: addDays(now, -77), nb: 29 },
  { date: addDays(now, -76), nb: 31 },
  { date: addDays(now, -75), nb: 31 },
  { date: addDays(now, -74), nb: 31 },
  { date: addDays(now, -73), nb: 30 },
  { date: addDays(now, -72), nb: 30 },
  { date: addDays(now, -71), nb: 31 },
  { date: addDays(now, -70), nb: 30 },
  { date: addDays(now, -69), nb: 29 },
  { date: addDays(now, -68), nb: 29 },
  { date: addDays(now, -67), nb: 30 },
  { date: addDays(now, -66), nb: 31 },
  { date: addDays(now, -65), nb: 31 },
  { date: addDays(now, -64), nb: 30 },
  { date: addDays(now, -63), nb: 31 },
  { date: addDays(now, -62), nb: 31 },
  { date: addDays(now, -61), nb: 31 },
  { date: addDays(now, -60), nb: 31 },
  { date: addDays(now, -59), nb: 31 },
  { date: addDays(now, -58), nb: 30 },
  { date: addDays(now, -57), nb: 31 },
  { date: addDays(now, -56), nb: 31 },
  { date: addDays(now, -55), nb: 29 },
  { date: addDays(now, -54), nb: 31 },
  { date: addDays(now, -53), nb: 31 },
  { date: addDays(now, -52), nb: 30 },
  { date: addDays(now, -51), nb: 31 },
  { date: addDays(now, -50), nb: 31 },
  { date: addDays(now, -49), nb: 31 },
  { date: addDays(now, -48), nb: 31 },
  { date: addDays(now, -47), nb: 31 },
  { date: addDays(now, -46), nb: 29 },
  { date: addDays(now, -45), nb: 31 },
  { date: addDays(now, -44), nb: 30 },
  { date: addDays(now, -43), nb: 31 },
  { date: addDays(now, -42), nb: 29 },
  { date: addDays(now, -41), nb: 29 },
  { date: addDays(now, -40), nb: 31 },
  { date: addDays(now, -39), nb: 31 },
  { date: addDays(now, -38), nb: 28 },
  { date: addDays(now, -37), nb: 31 },
  { date: addDays(now, -36), nb: 31 },
  { date: addDays(now, -35), nb: 30 },
  { date: addDays(now, -34), nb: 30 },
  { date: addDays(now, -33), nb: 31 },
  { date: addDays(now, -32), nb: 31 },
  { date: addDays(now, -31), nb: 30 },
  { date: addDays(now, -30), nb: 31 },
  { date: addDays(now, -29), nb: 31 },
  { date: addDays(now, -28), nb: 31 },
  { date: addDays(now, -27), nb: 30 },
  { date: addDays(now, -26), nb: 29 },
  { date: addDays(now, -25), nb: 30 },
  { date: addDays(now, -24), nb: 30 },
  { date: addDays(now, -23), nb: 31 },
  { date: addDays(now, -22), nb: 31 },
  { date: addDays(now, -21), nb: 31 },
  { date: addDays(now, -20), nb: 29 },
  { date: addDays(now, -19), nb: 31 },
  { date: addDays(now, -18), nb: 30 },
  { date: addDays(now, -17), nb: 31 },
  { date: addDays(now, -16), nb: 31 },
  { date: addDays(now, -15), nb: 31 },
  { date: addDays(now, -14), nb: 30 },
  { date: addDays(now, -13), nb: 28 },
  { date: addDays(now, -12), nb: 30 },
  { date: addDays(now, -11), nb: 31 },
  { date: addDays(now, -10), nb: 31 },
  { date: addDays(now, -9), nb: 30 },
  { date: addDays(now, -8), nb: 31 },
  { date: addDays(now, -7), nb: 31 },
  { date: addDays(now, -6), nb: 30 },
  { date: addDays(now, -5), nb: 30 },
  { date: addDays(now, -4), nb: 30 },
  { date: addDays(now, -3), nb: 31 },
  { date: addDays(now, -2), nb: 30 },
  { date: addDays(now, -1), nb: 30 },
  { date: addDays(now, 0), nb: 30 },
];
